import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { client } from "../config/prismic";

const Header = ({ page = false }) => {
  const [home, setHome] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const response = await client.getByType("home");
      setHome(response.results[0]?.data);
    };
    fetchData();
  }, []);

  const scrollToFooter = (e) => {
    if (e) e.preventDefault();
    const footer = document.getElementById("rs-footer");
    if (footer) {
      footer.scrollIntoView({ behavior: "smooth" });
    }
    setIsMobileMenuOpen(false);
  };

  if (!home) {
    return (
      <div className="flex items-center justify-center min-h-[100px] bg-dark-blue">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-pink"></div>
      </div>
    );
  }

  const navLinks = [
    { name: "Home", path: "/" },
    { name: "Call for Papers", path: "/cfp" },
    { name: "Submission Guidelines", path: "/guidelines" },
    { name: "Committee", path: "/committee" },
    { name: "Special Session", path: "/special-session" },
    // { name: "Review Process", path: "/review-process" },
    { name: "Contact Us", path: "" },
  ];

  return (
    <header
      className={`absolute top-0 left-0 w-full z-[999] transition-all duration-300 ${
        isMobileMenuOpen ? "bg-[#000929] shadow-lg" : "bg-transparent"
      }`}
    >
      <div className="container mx-auto px-4 py-2 md:py-3 flex items-center justify-between gap-3 xl:gap-6">
        {/* Logo 1 */}
        <div className="flex-shrink-0">
          <Link to="/">
            <img
              src={home.logo1.url}
              alt="Conference Logo 1"
              className="h-16 sm:h-20 md:h-24 lg:h-28 xl:h-36 w-auto object-contain transition-all"
            />
          </Link>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden lg:flex items-center justify-center flex-1 gap-4 xl:gap-6 min-w-0">
          {navLinks.map((link) => (
            link.name === "Contact Us" ? (
              <button
                key={link.name}
                onClick={scrollToFooter}
                className="text-white hover:text-[#d90845] transition-colors font-medium text-[11px] xl:text-xs uppercase tracking-wide whitespace-nowrap leading-none"
              >
                {link.name}
              </button>
            ) : (
              <Link
                key={`${link.name}-${link.path}`}
                to={link.path}
                className="text-white hover:text-[#d90845] transition-colors font-medium text-[11px] xl:text-xs uppercase tracking-wide whitespace-nowrap leading-none"
              >
                {link.name}
              </Link>
            )
          ))}
          <a
            href={home.registration_link[0].text}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#d90845] hover:bg-[#c7073f] text-white px-4 xl:px-5 py-2 rounded-full font-bold text-xs xl:text-sm transition-all transform hover:scale-105 shadow-lg whitespace-nowrap leading-none"
          >
            Registration
          </a>
        </nav>

        {/* Mobile Toggle */}
        <div className="lg:hidden flex items-center">
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="text-white p-2 hover:bg-white/10 rounded-lg transition-colors"
          >
            {isMobileMenuOpen ? (
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            ) : (
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16m-7 6h7"
                />
              </svg>
            )}
          </button>
        </div>

        {/* Logo 2 */}
        <div className="hidden sm:block flex-shrink-0 ml-4 lg:ml-0">
          <Link to="/">
            <img
              src={home.logo2.url}
              alt="Conference Logo 2"
              className="h-16 sm:h-20 md:h-24 lg:h-28 xl:h-36 w-auto object-contain transition-all"
            />
          </Link>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-300 ease-in-out ${
          isMobileMenuOpen ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
        } bg-[#000929] border-t border-white/10`}
      >
        <nav className="flex flex-col p-6 space-y-4">
          {navLinks.map((link) => (
            link.name === "Contact Us" ? (
              <button
                key={link.name}
                onClick={scrollToFooter}
                className="text-white hover:text-[#d90845] transition-colors font-medium text-lg border-b border-white/5 pb-2 ml-4 text-left"
              >
                {link.name}
              </button>
            ) : (
              <Link
                key={link.path}
                to={link.path}
                className="text-white hover:text-[#d90845] transition-colors font-medium text-lg border-b border-white/5 pb-2 ml-4"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {link.name}
              </Link>
            )
          ))}
          <a
            href={home.registration_link[0].text}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#d90845] text-white text-center py-4 rounded-xl font-bold text-xl shadow-lg mt-4 mx-4 transition-active"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            Registration
          </a>
          {/* Mobile Bottom Padding */}
          <div className="h-8"></div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
